import { Action } from '@ngrx/store';
import { Payment } from 'src/app/models/payment.model';

export const LOAD_PAYMENTS = '[Payments] Load Payment';
export const LOAD_PAYMENTS_FAIL = '[Payments] Load Payment Fail';
export const LOAD_PAYMENTS_SUCCESS = '[Payments] Load Payment Success';
export const CLEAR_PAYMENTS = '[Payments] Clear Payments';

export class LoadPayments implements Action {
  readonly type = LOAD_PAYMENTS;
}

export class LoadPaymentsFail implements Action {
  readonly type = LOAD_PAYMENTS_FAIL;
  constructor(public payload: any) {}
}

export class LoadPaymentsSuccess implements Action {
  readonly type = LOAD_PAYMENTS_SUCCESS;
  constructor(public payload: Payment[]) {}
}

export class ClearPayments implements Action {
  readonly type = CLEAR_PAYMENTS;
}

// action types
export type PaymentsAction =
  | LoadPayments
  | LoadPaymentsFail
  | LoadPaymentsSuccess
  | ClearPayments;
